import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const CART_URL = 'https://italia.kitonline.shop/cart/44568283611271:1';
const testimonials = [{
  name: 'Patrizia Conti',
  role: 'ITE Milano',
  initial: 'P',
  badge: '+1 livello in contabilità',
  text: "Insegno da 14 anni e questo è il primo strumento che mi fa davvero risparmiare tempo senza sacrificare la qualità. I miei studenti di quinta ITE hanno finalmente capito il Bilancio d'Esercizio al primo colpo."
}, {
  name: 'Giuseppe Marini',
  role: 'ITE Quinquennale, Bologna',
  initial: 'G',
  badge: 'Domeniche libere ritrovate',
  text: 'Il Bonus Excel è oro puro. Non devo più correggere i bilanci a mano la domenica sera. In 30 secondi ho la valutazione pronta. Ho recuperato ogni fine settimana.'
}, {
  name: 'Antonella Greco',
  role: 'IIS Tecnico, Napoli',
  initial: 'A',
  badge: '+5 ore libere a settimana',
  text: 'Le UDA sono perfettamente allineate al MIM e il Dirigente le ha approvate al primo invio. Recupero almeno 5 ore di preparazione a settimana — quasi una giornata libera.'
}, {
  name: 'Roberto Vitale',
  role: 'ITE Triennio, Torino',
  initial: 'R',
  badge: 'Maturità più serena',
  text: 'Il Volume 6 sulla Seconda Prova è eccezionale. Le simulazioni con casi aziendali reali mi hanno dimezzato i tempi di correzione. I miei studenti arrivano alla Maturità preparati.'
}, {
  name: 'Sabrina Russo',
  role: 'ITE Roma',
  initial: 'S',
  badge: 'Inclusione DSA & BES',
  text: "Ero scettica all'inizio: pensavo fosse il solito PDF generico. Invece ho trovato un percorso completo. Ho usato i materiali DSA con tre alunni BES e hanno passato la verifica di contabilità."
}, {
  name: 'Francesco Bianchi',
  role: 'Docente Precario, Bari',
  initial: 'F',
  badge: 'Pronto al volo',
  text: 'Cambio scuola ogni anno e dover ricostruire tutto da zero mi distruggeva. Con il Metodo arrivo in classe il primo giorno con il programma già impostato. Vale dieci volte il prezzo.'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4" data-id="element-282">
      <div className="max-w-6xl mx-auto" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-284">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-285">
            Recensioni Verificate
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-brand-cream mb-3 leading-tight" data-id="element-286">
            Cosa dicono i docenti che lo usano{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-287">
              ogni giorno
            </span>
          </h2>
          <p className="text-base sm:text-lg text-gray-400" data-id="element-288">
            Oltre 12.000 docenti italiani hanno già scelto il Metodo. Ecco cosa
            raccontano.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-289">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-card border border-white/5 p-6 rounded-2xl flex flex-col hover:border-brand-orange/30 transition-colors" data-id="element-290">
              <div className="flex items-center justify-between gap-2 mb-3" data-id="element-291">
                <div className="flex text-brand-gold" data-id="element-292">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-293" />)}
                </div>
                <div className="inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wider text-green-400" data-id="element-294">
                  <CheckCircle2Icon className="w-3.5 h-3.5" data-id="element-295" />
                  Verificato
                </div>
              </div>

              <p className="text-gray-300 font-medium italic mb-4 flex-grow" data-id="element-296">
                "{t.text}"
              </p>

              <div className="inline-block bg-brand-orange/15 border border-brand-orange/30 text-brand-orange text-xs font-bold px-3 py-1 rounded-full mb-4 self-start" data-id="element-297">
                ✓ {t.badge}
              </div>

              <div className="border-t border-white/10 pt-4 flex items-center gap-3" data-id="element-298">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-orange to-brand-amber flex items-center justify-center text-white font-black shrink-0" data-id="element-299">
                  {t.initial}
                </div>
                <div data-id="element-300">
                  <div className="font-bold text-brand-cream text-sm" data-id="element-301">
                    {t.name}
                  </div>
                  <div className="text-xs text-brand-orange" data-id="element-302">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8 text-center bg-brand-card border border-brand-orange/20 rounded-2xl p-6" data-id="element-303">
          <div className="flex justify-center -space-x-2 mb-3" data-id="element-304">
            {testimonials.map((t, i) => <div key={i} className="w-9 h-9 rounded-full bg-gradient-to-br from-brand-orange to-brand-amber flex items-center justify-center text-white font-black text-sm border-2 border-brand-card" data-id="element-305">
                {t.initial}
              </div>)}
          </div>
          <p className="text-brand-cream font-bold text-sm sm:text-base mb-1" data-id="element-306">
            +12.000 docenti hanno già scelto il Metodo
          </p>
          <p className="text-brand-gold font-black text-base sm:text-lg mb-5" data-id="element-307">
            ⭐ 4.9 / 5 media recensioni
          </p>
          <CTAButton href={CART_URL} className="w-full sm:max-w-sm mx-auto" data-id="element-308">
            VOGLIO IL METODO
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}